import { Collapse } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from '@/modules/header'
import { ga, traceEvent } from '@/utils/ga'

import { MyAudit } from './my-audit.component'
import { MyCustomer } from './my-customer.component'
import { MyFavorites } from './my-favorites.component'
import { MyPortfolios } from './my-portfolios.component'
import { MyProjects } from './my-projects.component'
import { MyStages } from './my-stages.component'

export const PersonalContainer = () => {
  const { t } = useTranslation()

  React.useEffect(() => {
    ga('event', traceEvent.navigation.events.show_navigation, {
      event_category: traceEvent.navigation.event_categories.ef_pmo,
      event_label: traceEvent.navigation.event_labels.home,
      action: traceEvent.navigation.action,
    })
  }, [])

  return (
    <>
      <Header />
      <Collapse
        ghost
        defaultActiveKey={['audit', 'stage-management', 'my-projects', 'my-portfolio', 'my-favorites', 'my-customer']}
      >
        <MyAudit header={t('personal.audit')} key='audit' />
        <MyStages header={t('personal.mystages')} key='stage-management' />
        <MyProjects header={t('personal.myprojects')} key='my-projects' />
        <MyPortfolios header={t('personal.myportfolios')} key='my-portfolio' />
        <MyCustomer header={t('personal.myCustomer')} key='my-customer' />
        <MyFavorites header={t('personal.myfavorites')} key='my-favorites' />
      </Collapse>
    </>
  )
}
